import { Attributes, LookupBase, NeoModel } from '@singularsystems/neo-core';

@NeoModel
export default class InvestorInvestmentPagedLookup extends LookupBase {

    public investorInvestmentId: number = 0;

    public refNo: string = "";

    public entity: string = "";

    public isAuthorised: boolean = false;

    public investorName: string = "";

    public investmentName: string = "";

    @Attributes.Float()
    public amount: number | null = null;

    // Client only properties / methods

    public get refNoOrId() {
        return this.refNo ? this.refNo : this.investorInvestmentId;
    }
}